module.exports = __webpack_public_path__ + "img/Ammo.ad1e39b3.png";